<template>
  <!-- Modal -->
    <div class="modal fade" id="registered" tabindex="-1" role="dialog" aria-labelledby="registeredTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
        <div class="modal-header border-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center">
            <div v-if="proceed==='begin'&&expired===false">
              <h5 class="modal-title pb-2" id="registeredTitle"><strong id="response">Sign in with email</strong></h5>
              <p class="pb-3">Enter the email address associated with your subscription, and we'll send a "magic link" to your inbox. Just click the link, and you're all set.</p>
              <p>
                <small>Your email</small> <br>
                <input v-model="email" type="email" class="email-input">
              </p>
            </div>
            <div v-else-if="proceed==='finish'" class="pt-2">
              <h5 class="modal-title pb-2" id="registeredTitle"><strong>Check your inbox</strong></h5>
              <p class="pb-3">We just emailed you a magic link to {{email}}. <br> Click the link to sign in</p>
            </div>
            <div v-else-if="proceed==='oops'" class="pt-2">
              <h5 class="modal-title pb-2" id="registeredTitle"><strong>Sorry, we didn't recognize that email.</strong></h5>
              <p class="pb-3">Would you like to sign in with a different email?</p>
              <p>
                <small>Your email</small> <br>
                <input v-model="email" type="email" class="email-input">
              </p>
            </div>
            <div v-else-if="proceed==='expired'||expired===true" class="pt-2">
              <h5 class="modal-title pb-2" id="registeredTitle"><strong>Your sign in link has expired.</strong></h5>
              <p class="pb-3">Enter the email address associated with your subscription, and we'll send a new magic link to your inbox.</p>
              <p>
                <small>Your email</small> <br>
                <input v-model="email" type="email" class="email-input">
              </p>
            </div>
        </div>
        <div class="modal-footer">
            <button v-if="proceed==='finish'" type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
            <button v-else type="button" v-on:click="validate()" class="btn btn-success">Continue</button>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Login',
  props: {
    api: String,
    location: String,
    expired: Boolean,
  },
  data: () => ({
    email: null,
    proceed: 'begin',
    validated: false,
  }),
  methods: {
    validate() {
      axios.post(this.api+'api/v1/listing/login', { email: this.email, location: this.location })
      .then((res)=>{ 
        if (res.data.result) {
          this.validated=true; this.proceed='finish';
        } else {
          this.validated=false; this.proceed='oops';
        }
      })
      .catch((err) => { console.error(err); this.proceed='oops'});
    },
    validEmail(email) {
        if (email===null) return;
        let regExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        //return !!email.match(regExp);
        if (this.email.match(regExp)) {
            return true;
        } else {
            return false;
        }
    },
    mounted() {
      //if (this.exired) this.proceed='expired'; // obsolete
    }
  }
}
</script>


<style scoped>
    .email-input {
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom: 1px solid grey;
        margin-bottom: 12px;
    }
</style>
